const legacyLabelToIcon = {
  'pulversläckare': 'fire-extinguisher',
  'skumsläckare': 'fire-extinguisher',
  'kolsyresläckare': 'fire-extinguisher',
  'vattenbrandsläckare': 'fire-extinguisher',
  'fettbrandsläckare': 'fire-extinguisher',
  'avd-litiumbrandsläckare': 'fire-extinguisher',
  'brandpost': 'fire-roll',
  'första hjälpen': 'first-aid',
  'larmknapp brand': 'fire-alarm',
  'larmknapp utrymning': 'evacuate',
  'nödtelefon': 'emergency-phone',
  'utrymningsväg': 'emergency-exit',
  'hänvisningsarmatur': 'guide-sign',
  'vägledande markering': 'guide-sign',
  'hänvisningsarmatur efterlysande': 'guide-sign',
  'vägledande markering efterlysande': 'guide-sign',
  'branddörr': 'fire-door1',
  'branddörr magnet': 'fire-door2',
  'branddörr självstängande': 'fire-door3',
  'centralapparat': 'central',
  'brandfilt': 'fire-blanket',
  'nödbelysning': 'emergency-light',
  'avstängning el': 'power-shutoff',
  'röklucka': 'smoke-hatch',
  'handlampa': 'flashlight',
  'hjärtstartare': 'heart-starter',
  'utrymningsplan': 'escape-plan',
  'sprinklercentral': 'sprinkler-central',
  'sprinkler manuell': 'sprinkler-manual',
  'brandvarnare': 'smoke-warner',
  'ögondusch': 'eye-shower',
  'brandcellsgräns': 'brandcellsgrans',
  'släcksystem kök': 'slacksystem_kok',
  'gassläcksystem': 'gasslacksystem',
  'punktskydd': 'punktskydd',
  'siren': 'siren',
  'centralapparat inbrott': 'centralapparat',
  'manöverpanel': 'manoverpanel',
  'rörelsedetektor': 'rorelsedetektor',
  'magnetkontakt': 'magnetkontakt',
  'rökdetektor': 'rokdetektor',
  'larmknapp': 'larmknapp_burglar',
  'vibrationsdetektor': 'vibrationsdetektor',
  'limmad glaskrossdetektor': 'limmad_glaskrossdetektor',
  'rörelsedetektor, foto': 'rorelsedetektor_foto',
  'aukustisk glaskrossdetektor': 'aukustisk_glaskrossdetektor',
  'sektionskort, rio': 'sektionskort_rio',
  'driftlarm': 'driftlarm',
  'läsare/fbk/passage': 'lasare_fbk_passage',
  'livekamera': 'livekamera',
  'router': 'router',
  'utrymningstrappa': 'utrymningstrappa',
  'utrymningsstege': 'utrymningsstege',
  'farlig eletrisk spänning': 'farlig_eletrisk_spanning',
  'truckladdningsplats': 'truckladdningsplats',
  'brandport': 'brandport',
  'adressenhet': 'adressenhet',
  'aukustiskt larmdon, siren': 'akustiskt_larmdon_siren',
  'brandförsvarstablå': 'brandforsvarstabla',
  'centralutrustning': 'centralutrustning',
  'dörrhallarmagnet': 'dorrhallarmagnet',
  'indikeringstablå, dold detektor': 'indikeringstabla_dold_detektor',
  'kombidetektor': 'kombidetektor',
  'linjerökdetektor reflektor': 'linjerokdetektor_reflektor',
  'linjerökdetektor sändare': 'linjerokdetektor_sandare',
  'nätsäkring': 'natsakring',
  'optiskt larmdon': 'optiskt_larmdon',
  'slutmotstånd': 'slutmotstand',
  'strömförsörjning': 'stromforsorjning',
  'värmedetektor, kapslad': 'varmedetektor_kapslad',
  'värmedetektor': 'varmedetektor',
  'gasbehållare': 'gasbehallare',
  'brandgasfläkt': 'brandgasflakt'
};


const legacyLabelToKey = {
  'pulversläckare': 'powder_extinguisher',
  'skumsläckare': 'foam_extinguisher',
  'kolsyresläckare': 'co2_extinguisher',
  'vattenbrandsläckare': 'water_extinguisher',
  'fettbrandsläckare': 'grease_extinguisher',
  'avd-litiumbrandsläckare': 'avd_lithium_extinguisher',
  'brandpost': 'hose_reel_cabinet',
  'första hjälpen': 'first_aid',
  'larmknapp brand': 'fire_alarm_button',
  'larmknapp utrymning': 'evacuation_alarm_button',
  'nödtelefon': 'emergency_phone',
  'utrymningsväg': 'evacuation_route',
  'hänvisningsarmatur': 'exit_sign_luminaire',
  'vägledande markering': 'exit_sign_luminaire',
  'hänvisningsarmatur efterlysande': 'photoluminescent_exit_sign',
  'vägledande markering efterlysande': 'photoluminescent_exit_sign',
  'branddörr': 'firedoor',
  'branddörr magnet': 'firedoor_magnet',
  'branddörr självstängande': 'firedoor_selfclosing',
  'centralapparat': 'control_panel',
  'brandfilt': 'fireblanket',
  'nödbelysning': 'emergency_lighting',
  'avstängning el': 'power_shutdown',
  'röklucka': 'smoke_vent',
  'handlampa': 'flashlight',
  'hjärtstartare': 'defibrillator',
  'utrymningsplan': 'evacuation_plan',
  'sprinklercentral': 'sprinkler_control_panel',
  'sprinkler manuell': 'manual_sprinkler',
  'brandvarnare': 'smoke_detector',
  'ögondusch': 'eyewash_station',
  'brandpost': 'fire_hydrant',
  'brandfarlig vara': 'flammable_substance',
  'truckladdningsplats': 'battery_charging',
  'lastplats': 'loading_area',
  'undercentral': 'substation'
};


const typeMetaByKey = {
  other: { icon: 'misc' },
  avd_lithium_extinguisher: { icon: 'fire-extinguisher' },
  battery_charging: { icon: 'truckladdningsplats' },
  co2_extinguisher: { icon: 'fire-extinguisher' },
  control_panel: { icon: 'central' },
  dangerous_voltage: { icon: 'misc' },
  defibrillator: { icon: 'heart-starter' },
  emergency_lighting: { icon: 'emergency-light' },
  emergency_phone: { icon: 'emergency-phone' },
  evacuation_alarm_button: { icon: 'evacuate' },
  evacuation_route: { icon: 'emergency-exit' },
  exit_sign_luminaire: { icon: 'guide-sign' },
  eyewash_station: { icon: 'eye-shower' },
  fire_alarm_button: { icon: 'fire-alarm' },
  fire_hydrant: { icon: 'fire-roll' },
  fireblanket: { icon: 'fire-blanket' },
  firedoor: { icon: 'fire-door1' },
  firedoor_magnet: { icon: 'fire-door2' },
  firedoor_selfclosing: { icon: 'fire-door3' },
  first_aid: { icon: 'first-aid' },
  flammable_substance: { icon: 'misc' },
  flashlight: { icon: 'flashlight' },
  foam_extinguisher: { icon: 'fire-extinguisher' },
  grease_extinguisher: { icon: 'fire-extinguisher' },
  hose_reel_cabinet: { icon: 'misc' },
  loading_area: { icon: 'misc' },
  manual_sprinkler: { icon: 'sprinkler-manual' },
  photoluminescent_exit_sign: { icon: 'guide-sign' },
  powder_extinguisher: { icon: 'fire-extinguisher' },
  power_shutdown: { icon: 'power-shutoff' },
  smoke_detector: { icon: 'rokdetektor' },
  smoke_vent: { icon: 'smoke-hatch' },
  sprinkler_control_panel: { icon: 'sprinkler-central' },
  substation: { icon: 'misc' },
  water_extinguisher: { icon: 'fire-extinguisher' },
  hand_extinguisher: { icon: 'fire-extinguisher' },
  evacuation_plan: { icon: 'escape-plan' },
  fire_compartment_boundary: { icon: 'brandcellsgrans' },
  kitchen_suppression_system: { icon: 'slacksystem_kok' },
  gas_suppression_system: { icon: 'gasslacksystem' },
  spot_protection: { icon: 'punktskydd' },
  address_unit: { icon: 'adressenhet' },
  acoustic_siren: { icon: 'akustiskt_larmdon_siren' },
  firefighters_panel: { icon: 'brandforsvarstabla' },
  door_holder_magnet: { icon: 'dorrhallarmagnet' },
  indicator_panel_hidden_detector: { icon: 'indikeringstabla_dold_detektor' },
  multi_sensor_detector: { icon: 'kombidetektor' },
  beam_detector_reflector: { icon: 'linjerokdetektor_reflektor' },
  beam_detector_transmitter: { icon: 'linjerokdetektor_sandare' },
  optical_alarm_device: { icon: 'optiskt_larmdon' },
  end_of_line_resistor: { icon: 'slutmotstand' },
  heat_detector_enclosed: { icon: 'varmedetektor_kapslad' },
  heat_detector: { icon: 'varmedetektor' },
  siren: { icon: 'siren' },
  intrusion_control_panel: { icon: 'centralapparat' },
  motion_detector: { icon: 'rorelsedetektor' },
  magnetic_contact: { icon: 'magnetkontakt' },
  intrusion_alarm_button: { icon: 'larmknapp_burglar' },
  vibration_detector: { icon: 'vibrationsdetektor' },
  glued_glass_break_detector: { icon: 'limmad_glaskrossdetektor' },
  motion_detector_camera: { icon: 'rorelsedetektor_foto' },
  acoustic_glass_break_detector: { icon: 'aukustisk_glaskrossdetektor' },
  zone_card: { icon: 'sektionskort' },
  remote_input_output: { icon: 'sektionskort_rio' }, // RIO
  fault_alarm: { icon: 'driftlarm' },
  reader_fire_department_access: { icon: 'lasare_fbk_passage' },
  live_camera: { icon: 'livekamera' },
  router: { icon: 'router' },
  escape_staircase: { icon: 'utrymningstrappa' },
  escape_ladder: { icon: 'utrymningsstege' },
  smoke_exhaust_fan: { icon: 'brandgasflakt' },
  zone_card_rio: { icon: 'sektionskort_rio' },
  operating_panel: { icon: 'manoverpanel' },
  dangerous_voltage: { icon: 'natsakring' }
};


export default {
  methods: {
    getType(key) {
      const normalized = this.normalizeTypeBare(key);
      if (typeMetaByKey[normalized]) return typeMetaByKey[normalized];

      const raw = (typeof key === 'string' ? key : key?.key || '').toLowerCase();
      const legacyIcon = legacyLabelToIcon[raw];
      if (legacyIcon) return { icon: legacyIcon };

      return typeMetaByKey.other;
    },

    getFireProtectionGroup(getFireProtectionGroup) {
      return fireProtectionGroupMap[getFireProtectionGroup];
    },
    getFireProtectionGroupMap() {
      return {
        0: this.$t('fire_protection_group.0'),
        1: this.$t('fire_protection_group.1'),
        2: this.$t('fire_protection_group.2'),
        3: this.$t('fire_protection_group.3'),
        4: this.$t('fire_protection_group.4'),
        5: this.$t('fire_protection_group.5')
      };
    },
    getFireProtectionTypes() {
      return Object.keys(typeMetaByKey)
        .map(key => ({
          key,
          label: this.$t(`flaw.category.${key}`),
          icon: typeMetaByKey[key].icon
        }))
        .sort((a, b) => a.label.localeCompare(b.label));
    },

    normalizeTypeBare(type) {
      if (!type) return '';
      const raw = (typeof type === 'string' ? type : type?.key || '').trim();
      if (!raw) return '';

      const bare = raw.startsWith('flaw.category.')
        ? raw.slice('flaw.category.'.length)
        : raw;

      if (typeMetaByKey[bare]) return bare;

      const lower = bare.toLowerCase();
      if (legacyLabelToKey[lower]) return legacyLabelToKey[lower];

      return bare;
    },

    displayType(fp) {
    const id = fp?.flawCategoryId;
    if (id) {
      const key = this.flawCategoryKeyById[String(id)];
      if (key) {
        const t = this.$t(`flaw.category.${key}`);
        return t !== `flaw.category.${key}` ? t : key;
      }
    }
    return this.tTypeKey(fp.inventoryType);
  },


    tTypeKey(type) {
      const raw = (typeof type === 'string' ? type : type?.key || '').trim();
      if (!raw) return '';

      const normalized = this.normalizeTypeBare(type);
      const fullKey = `flaw.category.${normalized}`;
      const translated = this.$t(fullKey);
      if (translated !== fullKey) return translated;

      const lower = raw.toLowerCase();
      if (legacyLabelToKey[lower]) {
        const fullLegacy = `flaw.category.${legacyLabelToKey[lower]}`;
        const t2 = this.$t(fullLegacy);
        if (t2 !== fullLegacy) return t2;
      }

      return raw;
    },

    displayFPName(fp) {
      const obj = fp?.flaw || fp;
      if (!obj) return '';

      const byType =
        this.tTypeKey(
          obj.category ?? obj.key ?? obj.inventoryType
        );
      return obj.name || obj.title || byType || '';
    },

    displayFPTitle(fp) {
      return this.displayFPName(fp);
    },

    tInstruction(instruction) {
      if (!instruction) return '';
      const raw = instruction.trim();
      const lookupKey = raw.startsWith('instructions.')
        ? raw
        : `instructions.${raw}`;
      const translated = this.$t(lookupKey);
      return translated !== lookupKey ? translated : instruction;
    },

    tDescription(description) {
      if (!description) return '';
      const key = description.trim();
      if (key.startsWith('descriptions.')) {
        const translated = this.$t(key);
        if (translated !== key) return translated;
      }
      return description;
    },
    preferCategoryLabel(fp) {
      const obj = fp?.fireProtection || fp || {};
      const isGlobal = obj?.companyId == null;

      var idKey = obj?.flawCategoryId
        ? this.flawCategoryKeyById?.[String(obj.flawCategoryId)]
        : null;

      idKey = obj?.flawCategory?.Id
        ? this.flawCategoryKeyById?.[String(obj.flawCategoryId)]
        : null;

      const normKey = this.normalizeTypeBare(
        idKey ||
        obj?.category ||
        obj?.key ||
        obj?.inventoryType ||
        ''
      );

      const hasKey = !!normKey;
      const containsOther = hasKey && normKey.toLowerCase().includes('other');

      const catI18nKey = hasKey ? `flaw.category.${normKey}` : '';
      const translatedCategory =
        hasKey ? this.$t(catI18nKey) : '';

      const hasTranslation = hasKey && translatedCategory !== catI18nKey;
      if (isGlobal && hasKey && !containsOther && hasTranslation) {
        return translatedCategory;
      }

      return this.displayFPName(obj);
  }
  },
  props:{
    flawCategories: { type: Array, default: () => [] },
    flawCategoryMap: { type: Object, default: () => null }
  },

  computed: {
    typeOptions() {
      return Object.keys(typeMetaByKey)
        .map(key => ({
          key,
          label: this.$t(`flaw.category.${key}`),
          icon: typeMetaByKey[key].icon
        }))
        .sort((a, b) => a.label.localeCompare(b.label));
    },
    flawCategoryKeyById() {
      const map = {};

      const sources = [
        ...(this.listFireProtections || []),
        ...(this.roundFireProtections || []),
        ...((this.localRoundPlanning?.fireProtections) || []),
      ];

      sources.forEach(fp => {
        const obj = fp?.fireProtection || fp || {};
        const id = obj.flawCategoryId;
        const derivedKey = this.normalizeTypeBare(
          obj.category || obj.key || obj.fireProtectionType || obj.inventoryType || ''
        );
        if (id && derivedKey) {
          map[String(id)] = derivedKey;
        }
      });

      return map;
  }
  }
};
